module.exports = __webpack_public_path__ + "img/gui_zhucan.18fa6879.png";